import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnerIdFragmentGql } from './OwnerIdFragmentGql';

// Should fetch same nodes as VirtualConnectionDownstreamOwnersQuery
export const VirtualConnectionDownstreamOwnerIdsQueryGql: DocumentNode = gql`
query VirtualConnectionDownstreamOwnerIdsQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  virtualConnections(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerIdFragment
      }
    }
  }
}
${OwnerIdFragmentGql}
`;
